  import axios from "axios";
 
 //const API = "http://localhost:3001";
//const API = "https://fakestoreapi.com";

//export default API;



const API = axios.create({
    baseURL: "http://127.0.0.1:8000/api",
    headers: {
        Accept: "application/json",
    },
});

export default API;